import { useOperator } from "hooks"
import React from "react"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import { publicRoutes } from "router/routes"
import "./Footer.scoped.scss"

type FooterProps = {
	className?: string
}

const Footer: React.FC<FooterProps> = ({ className = "" }) => {
	const { t } = useTranslation()
	const { currentOperator } = useOperator()

	return (
		<footer className={`c-footer md:flex py-4 md:px-4 ${className}`}>
			{currentOperator && (
				<nav className="flex items-center justify-center flex-col md:flex-row">
					<a
						href={currentOperator.legalNoticeUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="px-2"
					>
						{t("menu.legal_notice")}
					</a>

					<a
						href={currentOperator.cguUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="px-2"
					>
						{t("menu.cgu")}
					</a>

					<a
						href={currentOperator.privacyPolicyUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="px-2"
					>
						{t("menu.privacy-policy")}
					</a>

					<NavLink to={publicRoutes.faq.path} className="px-2">
						{t("menu.faq")}
					</NavLink>

					<NavLink to={publicRoutes.contact.path} className="px-2">
						{t("menu.contact")}
					</NavLink>
				</nav>
			)}

			{process.env.REACT_APP_VERSION && (
				<div className="px-2 text-center">Version: {process.env.REACT_APP_VERSION}</div>
			)}
		</footer>
	)
}

export default Footer
